import React from 'react';
import './spinner.css';

const Spinner = ({ fullPage }) => {
    return (
        <div className={`spinner-container ${fullPage ? 'full-page' : ''}`}>
            <div className="wrapldsSpinner"><div className="ldsSpinner" ><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
        </div>
    );
};

export default Spinner;
